"use strict";

angular.module('app.controllers.alarmActive', []).
config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('alarm-active', {
        parent: 'site',
        url: '/alarm-active',
        templateUrl: 'views/alarms.html',
        controller: 'ActiveAlarmsCtrl',

        breadcrumb: {
            initialState: true,
            name: 'NAV_ActiveAlarm',
            label : 'active-alarms'
        },
    });
}]).
controller("ActiveAlarmsCtrl",
    ['$scope', '$rootScope', 'ApiAlarmService', 'f_Info', 'viewMenuBarService', 'API', 'xCenterConfig', '$filter',
        function ($scope, $rootScope, ApiAlarmService, f_Info, viewMenuBarService, API, xCenterConfig, $filter) {
            'ngInject';

            viewMenuBarService.setFavorite(false);
            viewMenuBarService.setButtons({});

            // Init Alarm
            $scope.Alarms = [];
            //$scope.withFilterDateButton = false;
            $scope.$on('InitActualView', function () {
                $scope.init();
            });
            $scope.init = function () {

                //MasterService.refreshNavigationByReload('activealarms', 'activealarms');

                // Fetch Alarms from Factory
                ApiAlarmService.fetchCurrentAlarms().then(function(data){
                    const alarmCounter = data.filter(item => {
                        return ((item.AlarmType === 4 || item.AlarmType === 2) && item.Cleared === false) ? true : false;
                    }).length;

                    const warningCounter = data.filter(item => {
                        return (item.AlarmType === 1 && item.Cleared === false) ? true : false;
                    }).length;
                    
                    $rootScope.$broadcast('active-alarm-update',{alarmCounter:alarmCounter, warningCounter:warningCounter});
                });

                // Show Clearbutton
                $rootScope.clearbutton = true;
                $scope.resetAlarmButton = true;
                $scope.allowMessage = true;
                $rootScope.backbutton = true;
                $scope.showClearedAlarms = false;

                // What to do, when pressing the button
                // => ClearAlarms
                $rootScope.clearFunction = function () {
                    $rootScope.loading = true;

                    var api = new API();
                    var alarmsParams = {
                        'DeviceId': xCenterConfig.var.guid_All
                    };
                    api.Alarm.ClearCurrentAlarms(alarmsParams).$promise
                    .then(function() {
                        $rootScope.loading = false;
                        ApiAlarmService.fetchCurrentAlarms();
                    });
                };


            };
            $scope.init();
            /* $scope.$watch('filterDate',function(){
             alert('123');
             })*/
            // When ne Alarms coming in, fill the array
            $scope.$on('currentAlarmsUpdate', function () {
                if (!$scope.filterDataOptions) {
                    $scope.Alarms = prepareReadableText(ApiAlarmService.getCurrentAlarms());
                }
            });

            function prepareReadableText(alarms) {
                alarms.forEach(function(alarm) {
                    if (alarm.Description) {
                        alarm.Description = alarm.Description.trim().replace(/(?:\r\n|\r|\n)/g, "<br/>");
                    }
                    if (alarm.Details) {
                        alarm.Details = alarm.Details.trim().replace(/(?:\r\n|\r|\n)/g, "<br/>");
                    }
                    if (alarm.ShortText) {
                        alarm.ShortText = alarm.ShortText.trim();
                    }
                    if (alarm.AlarmData && $scope.hasAnyProperties(alarm.AlarmData)) {
                        for (var alarmDataProp in alarm.AlarmData) {
                            if (alarm.AlarmData.hasOwnProperty(alarmDataProp) && alarm.AlarmData[alarmDataProp]) {
                                alarm.AlarmData[alarmDataProp] = alarm.AlarmData[alarmDataProp].trim().replace(/(?:\r\n|\r|\n)/g, "<br/>");
                            }
                        }
                    }
                });
                return alarms;
            }

            $scope.hasAnyProperties = function(obj) {
                return Object.keys(obj).length;
            };

            // When user level changes, update interface
            $scope.$on('UserlevelChange', function () {
                if (!$scope.filterDataOptions) {
                    $scope.Alarms = ApiAlarmService.getCurrentAlarms();
                }
            });


            // Filter by Alarm Type
            $scope.alarmType = function (at) {
                if ($scope.at === undefined) {
                    $scope.at = {'AlarmType': at};
                    $scope.at.Cleared = false;
                } else if ($scope.at.AlarmType === at) {
                    $scope.at = undefined;
                } else {
                    $scope.at = {'AlarmType': at};
                    $scope.at.Cleared = false;
                }
            };

            // Show popup with Alarm infos
            $scope.showInfo = function (a) {
                //return true;
                f_Info.addInfo(
                    {
                        "Big": true,
                        "Type": 9,
                        "Title": a.ShortText,
                        "Code": a.Alarmcode,
                        "CodeNr": a.Alarmcode,
                        "Zeit": a.TimeStamp,
                        "DisplayText": 'AlarmEntryId:' + a.AlarmEntryId + '\n' + 'Source: ' + a.Source + '\n' + 'DeviceId: ' + a.DeviceId + '\n' + 'Device Name: ' + a.DeviceName + '\n' + 'Details: ' + a.Details
                    });
            };

            // Clear one alarm.
            $scope.clearAlarm = function (a) {
                $rootScope.loading = true;

                var api = new API();
                var alarmsParams = {
                    'DeviceId': a.DeviceId
                };
                api.Alarm.ClearCurrentAlarms(alarmsParams).$promise
                .then(function() {
                    for (var i = $scope.Alarms.length - 1; i >= 0; i--) {
                        if ($scope.Alarms[i].AlarmFlagConfigId === a.AlarmFlagConfigId) {
                            $scope.Alarms.splice(i, 1);
                        }
                    }
                    $rootScope.loading = false;
                });
            };
        }]);
